// extracted by mini-css-extract-plugin
export default {"textContainer":"Assistant_textContainer__oKskW","buttons":"Assistant_buttons__rmJ0N","pictureContainer":"Assistant_pictureContainer__Og-a8","img":"Assistant_img__74dU6"};